export default __webpack_public_path__ + "static/layout-example-light-da2f96ec85bb3f317efa16cf230bcbf6aa611de4b19a5535df0350bf0c72bf38.png";